
export const PAYLINK_PAYMENT_REQUEST = 'https://miapago.io/paylink/request';
export const PAYLINK_PAYMENT_REQUEST_V = 'https://miapago.io/paylink/request/v0.1.0';
export const PAYLINK_PAYMENT_INSTRUCTION = 'https://miapago.io/paymentinstruction';
export const OPEN_BANKING_DOMESTIC_PAYMENT_METHOD = 'https://miapago.io/ob/domesticpayment'
